export function cloudinaryImageUrl(url, width) {
  if (typeof url !== 'string' || !url.includes('res.cloudinary.com/') || !url.includes('/image/upload/')) return url;
  if (/\/image\/upload\/[^/]*(?:f_auto|q_auto|w_\d+)/.test(url)) return url;
  const safeWidth = Math.max(1, Math.round(Number(width) || 0));
  if (!safeWidth) return url;
  return url.replace('/image/upload/', `/image/upload/f_auto,q_auto,c_limit,w_${safeWidth}/`);
}
